import type { BiomeId } from "../content/schemas";

/**
 * Per-biome lighting / fog presentation (render-only).
 * Keeps combat readability: warm industrial fill, not cinematic wash.
 */
export type BiomeAtmosphere = {
  hemiSky: number;
  hemiGround: number;
  hemiIntensity: number;
  sunColor: number;
  sunIntensity: number;
  sunPosition: readonly [number, number, number];
  fogNearMult: number;
  fogFarMult: number;
  /** Soft pad fill when carrier point light is enabled. */
  carrierLightColor: number;
  carrierLightIntensity: number;
  backgroundLift: number;
};

export const BIOME_ATMOSPHERE: Record<BiomeId, BiomeAtmosphere> = {
  ash_band: {
    hemiSky: 0xc4b49a,
    hemiGround: 0x1a1510,
    hemiIntensity: 0.62,
    sunColor: 0xffe2c0,
    sunIntensity: 1.55,
    sunPosition: [42, 78, 18],
    fogNearMult: 0.95,
    fogFarMult: 1.05,
    carrierLightColor: 0xd4b06a,
    carrierLightIntensity: 1.8,
    backgroundLift: 0.02,
  },
  rust_flats: {
    hemiSky: 0xd0a888,
    hemiGround: 0x1c100c,
    hemiIntensity: 0.58,
    sunColor: 0xffd0a8,
    sunIntensity: 1.7,
    sunPosition: [36, 72, 28],
    fogNearMult: 0.88,
    fogFarMult: 0.95,
    carrierLightColor: 0xe09050,
    carrierLightIntensity: 2.0,
    backgroundLift: 0.03,
  },
  scrap_canyon: {
    hemiSky: 0x9ab0b8,
    hemiGround: 0x0c1014,
    hemiIntensity: 0.55,
    sunColor: 0xd8e4f0,
    sunIntensity: 1.45,
    sunPosition: [28, 85, 32],
    fogNearMult: 0.82,
    fogFarMult: 0.9,
    carrierLightColor: 0x8ab0c8,
    carrierLightIntensity: 1.6,
    backgroundLift: 0.015,
  },
};

export function atmosphereFor(biomeId: string): BiomeAtmosphere {
  if (biomeId in BIOME_ATMOSPHERE) {
    return BIOME_ATMOSPHERE[biomeId as BiomeId];
  }
  return BIOME_ATMOSPHERE.ash_band;
}
